import React, { useEffect } from "react";
import { Typography, Form, Alert } from "antd";
import CustomButton from '../../../components/CustomButton/Button';
import CustomInput from "../../../components/CustomInput/Input"
import { useDispatch, useSelector } from "react-redux";
import { editBusDets, getBusinessDetailedView, clearProfileError } from "../../../redux/slices/BusinessProfileSlice";
import { BTN_TXT, GLOBAL_CONSTANTS } from "../../../constants/constants";
import { websiteRules, businessDescriptionRules, FinancialSummaryRules, CommentsRules, nameRules } from "../../../helpers/helpers";

const { Title } = Typography;

const EditInputForm = ({
    setEditInputModelOpen,
    isWebsite,
    website,
    isBusDescription,
    busDescription,
    isFinancialSummary,
    financialSummary,
    comments,
    isComments,
    isContactName,
    contactName,
    setIsWebsite,
    setIsBusDescription,
    setIsFinancialSummary,
    setIsComments,
    setIsContactName
}) => {
    const dispatch = useDispatch();
    const { editDetailError, editDetailLoading } = useSelector((state) => state.profile1);
    const { user } = useSelector((state) => state.auth);
    const [form] = Form.useForm();

    useEffect(() => {
        return () => {
            dispatch(clearProfileError());
        };
    }, [dispatch]);

    const handleOnFinish = async (values) => {
        let payload = {}
        if (isContactName) {
            payload.pocName = values.ContactName
        } else if (isWebsite) {
            payload.website = values.Website
        } else if (isBusDescription) {
            payload.description = values.BusinessDescription
        } else if (isFinancialSummary) {
            payload.financialSummary = values.FinancialSummary
        } else {
            payload.comments = values.Comments
        }

        const res = await dispatch(editBusDets(payload));
        if (res.payload.statusCode === 201) {
            setEditInputModelOpen(false);
            if (isContactName) {
                if (setIsContactName) setIsContactName(false);
            } else if (isWebsite) {
                setIsWebsite(false);
            } else if (isBusDescription) {
                setIsBusDescription(false);
            } else if (isFinancialSummary) {
                setIsFinancialSummary(false);
            } else if (isComments) {
                setIsComments(false);
            }
            dispatch(getBusinessDetailedView(user.orgId));
        }
    };


    const getTitle = () => {
        if (isContactName) return GLOBAL_CONSTANTS.NAME_AS_PER_PAN;
        if (isWebsite) return GLOBAL_CONSTANTS.WEBSITE;
        if (isBusDescription) return GLOBAL_CONSTANTS.BUS_DESC;
        if (isFinancialSummary) return GLOBAL_CONSTANTS.FIN_SUMMARY;
        if (isComments) return GLOBAL_CONSTANTS.COMMENTS;
        return "";
    };

    return (
        <>
            <Title level={4}>Edit {getTitle()}</Title>
            <Form
                form={form}
                layout="vertical"
                className="com-address-form"
                onFinish={handleOnFinish}
                initialValues={{
                    remember: true,
                    ContactName: contactName || null,
                    Website: website || null,
                    BusinessDescription: busDescription || null,
                    FinancialSummary: financialSummary || null,
                    Comments: comments || null
                }}
            >
                {isContactName && (
                    <CustomInput
                        label="Contact Name"
                        name="ContactName"
                        placeholder="Please Enter Contact Name"
                        rules={nameRules("Contact")}
                    />
                )}

                {isWebsite && (
                    <CustomInput
                        label="Website"
                        name="Website"
                        placeholder="Please Enter Website"
                        rules={websiteRules}
                    />
                )}

                {isBusDescription && (
                    <CustomInput
                        label="Business Description"
                        name="BusinessDescription"
                        placeholder="Please Enter Business Description"
                        type="textarea"
                        rows={8}
                        rules={businessDescriptionRules}
                    />
                )}

                {isFinancialSummary && (
                    <CustomInput
                        label="Financial Summary"
                        name="FinancialSummary"
                        placeholder="Please Enter Financial Summary"
                        type="textarea"
                        rows={8}
                        rules={FinancialSummaryRules}
                    />
                )}

                {isComments && (
                    <CustomInput
                        label="Comments"
                        name="Comments"
                        placeholder="Please Comments"
                        type="textarea"
                        rows={8}
                        rules={CommentsRules}
                    />
                )}

                {editDetailError && <Alert style={{ marginBottom: 20 }} message={editDetailError} type="error" showIcon />}

                <Form.Item>
                    <CustomButton type="primary" loading={editDetailLoading} htmlType="submit" block>
                        {BTN_TXT.SAVE}
                    </CustomButton>
                </Form.Item>
            </Form>
        </>
    )
}

export default EditInputForm
